import { get } from 'lodash'

export type ColumnPropertyType =
  | 'String'
  | 'Object'
  | 'Array'
  | 'Date'
  | 'DateTime'
  | 'Number'
  | 'Currency'
  | 'RouterLink'
  | 'Link'
  | 'Telephone'
  | 'Email'

export class ColumnDef<RowModel = any> {
  verboseName: string
  key: string
  /**
   * Only available in the mmx-advanced-table-rx usage,
   */
  secondaryKey: string
  secondary: string
  order: number
  propertyType: ColumnPropertyType
  isArray: boolean
  canSort: boolean
  sortDirection: 'asc' | 'desc'
  sortBy: string[]
  visible: boolean
  placeholder: string
  timezone?: string
  format: string | false | ((row: RowModel) => string)
  link: (record: RowModel) => string
  sortByAccessor: (record: RowModel) => string[]
  propertyAccessor: (obj: any, thisRef: RowModel) => any | any[]
  constructor(options: Partial<ColumnDef<RowModel>> = {}) {
    this.key = options.key
    this.secondaryKey = options.secondaryKey
    this.secondary = options.secondary
    this.visible = typeof options.visible === 'boolean' ? options.visible : true
    this.order = options.order || 0
    this.verboseName = options.verboseName
    this.sortDirection = options.sortDirection
    this.sortBy = options.sortBy
    this.propertyType = options.propertyType || 'String'
    this.isArray = options.isArray ?? false
    this.link = options.link
    this.placeholder = options.placeholder
    this.timezone = options.timezone
    this.format =
      options.format === false
        ? null
        : options.format === null && this.propertyType === 'Number'
          ? '.2'
          : options.format

    this.canSort = options.canSort || false
    const propertyAccessor = (j, element) => get(element, this.key)
    this.sortByAccessor = options.sortByAccessor
    this.propertyAccessor = options.propertyAccessor ?? propertyAccessor
  }
}
